import { BulbOutlined, LoadingOutlined } from "@ant-design/icons";
import { IntelligenceFormFieldsEnum } from "@src/pages/intelligence-search/enum";
import { trackEventPayload } from "@src/util/track-event-payload";
import { Button, Modal, Select } from "antd";
import { FormInstance } from "antd/lib";
import React from "react";
import { useTracking } from "react-tracking";
import { AutoInsight } from "../auto-insight";
import { SweetVisEda } from "../sweetvis-eda";
import { SearchResultType } from "@src/pages/intelligence-search/list";

export const InsightModal: React.FC<{ form: FormInstance; loadResult?: SearchResultType }> = ({ form, loadResult }) => {
    const { trackEvent } = useTracking();
    const [open, setOpen] = React.useState(false);
    const [insightMode, setInsightMode] = React.useState("auto-insight");
    const [isEdaLoading, setIsEdaLoading] = React.useState(false);
    return (
        <div>
            <Modal
                title={
                    <div className="flex items-center justify-start gap-2">
                        <Select
                            size="small"
                            style={{ width: 120 }}
                            value={insightMode}
                            onChange={(value) => setInsightMode(value)}
                            options={[
                                {
                                    label: "Auto Insight",
                                    value: "auto-insight",
                                },
                                {
                                    label: "EDA Report",
                                    value: "eda-report",
                                },
                            ]}
                        />
                    </div>
                }
                open={open}
                width={"100%"}
                centered
                onCancel={() => {
                    setOpen(false);
                }}
                footer={(
                    originNode: React.ReactNode,
                    extra: {
                        OkBtn: React.FC;
                        CancelBtn: React.FC;
                    },
                ) => <extra.CancelBtn />}
            >
                <div className="h-[70vh] w-full overflow-hidden">
                    {insightMode === "auto-insight" && open && <AutoInsight loadResult={loadResult} />}
                    <div style={{ display: insightMode === "eda-report" ? "block" : "none" }}>
                        <SweetVisEda form={form} setIsEdaLoading={setIsEdaLoading} />
                    </div>
                </div>
            </Modal>
            <Button
                onClick={() => {
                    trackEvent(
                        trackEventPayload.intelligenceSearchAutoInsightClickOpen(
                            form.getFieldValue(IntelligenceFormFieldsEnum.PRODUCT_CODE),
                        ),
                    );
                    setOpen(true);
                }}
                icon={isEdaLoading ? <LoadingOutlined /> : <BulbOutlined />}
            >
                View Insight
            </Button>
        </div>
    );
};
